import React from 'react'
import { TextTypes } from '../../../types'
import { Text } from '../../atoms'

/**
 * Stack trace component. Not meant for end users, only debugging purposes.
 */
export const StackTrace = ({ error }: { error: Error }) => (
    <div className="bg-error-100 border border-error-600 p-4 mt-6 break-words">
        <Text type={TextTypes.HEADING_3} className="mb-4">
            {error.message}
        </Text>
        <Text>{error.stack}</Text>
    </div>
)
